import login from './login';

export default {
  language: 'sk-SK',
  country: 'sk',
  name: 'Slovenčina',
  embeddedLocale: login,
};
